require('./ui-bootstrap-tpls');
module.exports = 'ui.bootstrap';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/index.js
// module id = 121
// module chunks = 0